// extracted by mini-css-extract-plugin
module.exports = {"fitSurvey":"gr","fitSurveyContent":"hr","fitSurveyTooltip":"ir","fitSurveyRating":"jr","ratingText":"kr","percentBar":"lr","percentNumber":"mr","fitSection":"nr"};